import { useState } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { BootcampProductAPIStat } from '~/redux/apis/user-stats-api'
import { getColorClassnameFromId } from '~/statistics/utils/common.utils'

import ProductCardContainer from '../ProductCardContainer'

import Details from './Details'
import Summary from './Summary'

export default function BootcampProductStatCard({ product }: { product: BootcampProductAPIStat }): React.ReactElement {
  const [showContent, setShowContent] = useState(false)

  const cardName = `${product.subjectTitle} - ${product.videoCourseName}`

  const onToogle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName, expanded: !showContent })
    setShowContent(!showContent)
  }

  const borderColorClassname = getColorClassnameFromId(product.id)

  return (
    <ProductCardContainer innerClassName={`border-2 border-${borderColorClassname}`} noGradient>
      <Summary onClick={onToogle} product={product} showContent={showContent} />
      {showContent && <Details product={product} />}
    </ProductCardContainer>
  )
}
